import { DataTable, Dialog, FileInput, FormLabel, Heading, Loader, Select } from "@/components";
import useGLSetup from "./useGLSetup";
import { Button, Input, Switch } from "@/components/ui";
import { ArrowDownToLine, ArrowUpFromLine, Search } from "lucide-react";
import { AddEditGlMaster } from "./AddEditGlMaster";

const GLSetup = () => {
  const {
    setGlobalFilter,
    globalFilter,
    onAdd,
    isLoadingGlMaster,
    columns,
    setOpenDialog,
    onCloseDialog,
    openDialog,
    onRowClick,
    rowSelected,
    isView,
    showBulkDialog,
    setShowBulkDialog,
    file,
    fileInputRef,
    setFile,
    onUpload,
    isBulkDownloading,
    onBulkDownload,
    onBulkUpload,
    isUploadPending,
    communityList,
    isCommunityLoading,
    communityId,
    onCommunityChange,
    isMobile,
    hasAddPermission,
    activeOnly,
    setActiveOnly,
    bulkUploadTitle,
    rows
  } = useGLSetup();
  

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title="GL Setup"
            // breadcrumbData={breadcrumbData}
          />
          {isMobile && hasAddPermission ? <Button onClick={onAdd}>+ Add</Button> : <></>}
        </div>
        <div className="flex flex-row items-center gap-4">
          <div className="relative w-full sm:w-72 sm:min-w-72 sm:max-w-72 shrink-0">
            <FormLabel>Select Community</FormLabel>
            <Select
              placeholder={""}
              searchPlaceholder={""}
              noDataPlaceholder={"Community No Found"}
              options={communityList?.data?.map((data: any) => ({
                value: data?.communityId?.toString(),
                label: data?.name,
              }))}
              value={communityId?.toString()}
              onChange={onCommunityChange}
              className="h-[36px] w-full"
              disabled={isCommunityLoading}
            />
          </div>
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && hasAddPermission && (
            <Button onClick={onAdd}>+ Add</Button>
          )}
        </div>
      </div>
      
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="hidden lg:block" />
        <div className="flex flex-row items-center gap-4">
          <div className="flex items-center gap-2 text-xs text-slate-700">
            <span
              className={`cursor-pointer text-center leading-4 ${
                activeOnly ? "text-primary" : ""
              }`}
              onClick={() => setActiveOnly(true)}
            >
              Active
            </span>

            <Switch
              checked={!activeOnly}
              onCheckedChange={(checked) => setActiveOnly(!checked)}
              disabled={isLoadingGlMaster}
              className="data-[state=unchecked]:bg-primary data-[state=checked]:bg-slate-300"
            />

            <span
              className={`cursor-pointer text-center leading-4 ${
                !activeOnly ? "text-primary" : ""
              }`}
              onClick={() => setActiveOnly(false)}
            >
              Inactive
            </span>
          </div>
          <Button variant="ghost" className="text-gray-500" disabled={isBulkDownloading} onClick={onBulkDownload}>
            <ArrowDownToLine /> Bulk Download
          </Button>
          {hasAddPermission ? (
            <Button variant="ghost" className="text-gray-500" disabled={isUploadPending || isBulkDownloading} onClick={onBulkUpload}>
              <ArrowUpFromLine /> Bulk Upload
            </Button>
          ) : <></>}
        </div>
      </div>

      {/* Responsive Table */}
      {isLoadingGlMaster ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={rows.sort(
              (a: any, b: any) => a.glAccountNumber - b.glAccountNumber
            )}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
            paginationArr={[5, 10, 20, 50, 100]}
          />
          {openDialog && (
            <AddEditGlMaster
              setOpen={setOpenDialog}
              onCloseDialog={onCloseDialog}
              open={openDialog}
              isView={isView}
              rowSelected={rowSelected}
            />
          )}
        </>
      )}
      <Dialog
        open={showBulkDialog}
        setOpen={setShowBulkDialog}
        title={bulkUploadTitle}
        onSave={onUpload}
        isLoading={isUploadPending}
      >
        <div className="relative">
          <label className="text-[14px]">File Upload</label>
          <FileInput
            file={file}
            fileInputRef={fileInputRef}
            setFile={setFile}
            accept=".xlsx, .excel"
          />
        </div>
      </Dialog>
    </div>
  );
};

export default GLSetup;
